module.exports = __webpack_public_path__ + "static/media/vuetranslator.c91bae52.webp";